module.exports = __webpack_public_path__ + "static/media/DSC03786.76e8980c.jpg";